import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  Box,
  Stack,
} from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import { AuthContext } from '../context/AuthContext';
import { ErrorContext } from '../context/ErrorContext';
// import { hasCompletedPersonalInfo } from './ManageSelf';
import { ProfileCompletionModal } from './JobDrawer';

export default function JobCard({ job, status, onApplyClick, isDrawerOpen = false }) {
  // eslint-disable-next-line no-unused-vars
  const { user } = React.useContext(AuthContext);
  const { setError } = React.useContext(ErrorContext);
  const [showProfileModal, setShowProfileModal] = React.useState(false);

  const getPaymentFrequencyDisplay = (frequency) => {
    const frequencies = {
      'YEARLY': '/ Year',
      'MONTHLY': '/ Month',
      'WEEKLY': '/ Week',
      'DAILY': '/ Day',
      'HOURLY': '/ Hour'
    };
    return frequencies[frequency] || '';
  };

  const handleCardClick = () => {
    if (job.is_active === false) {
      setError("This job is currently inactive");
      return;
    }

    // Use the onApplyClick prop if provided (drawer mode), otherwise use default navigation
    if (onApplyClick) {
      onApplyClick(job.uuid);
    } else {
      window.location.href = `/opportunities/${job.uuid}/details`;
    }
  };

  if (!job) return null;
  return (
    <Card
      onClick={handleCardClick}
      sx={{
        width: '100%',
        minWidth: 0,
        height: 'auto',
        minHeight: 160,
        transition: 'all 0.3s',
        boxShadow: 1,
        '&:hover': {
          boxShadow: 4,
          transform: 'translateY(-2px)',
          borderColor: 'primary.main',
        },
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        m: 0,
      }}
    >
      <CardHeader
        sx={{ pb: 1, px: 3, pt: 2 }} // Increased padding and explicit top padding
        title={
          <Typography
            fontWeight={600}
            color="text.primary"
            sx={{
              transition: 'color 0.2s',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: isDrawerOpen ? 'normal' : 'nowrap',
              display: 'block',
              width: '100%',
              maxWidth: '100%',
              wordBreak: isDrawerOpen ? 'break-word' : 'normal',
            }}
          >
            {isDrawerOpen ? job.title : (job.title && job.title.length > 40 ? `${job.title.substring(0, 40)}...` : job.title)}
          </Typography>
        }
        action={null}
        subheader={
          // <Box display="flex" alignItems="center" gap={1} mt={0.5}>
          //   <BusinessIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          //   <Typography variant="body2" color="text.secondary" fontWeight={500}>
          //     {job.recruiter_organizations?.[0]?.organisation?.name || job.company || 'Priyo'}
          //   </Typography>
          // </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            {/* <AttachMoneyIcon sx={{ fontSize: 18 }} /> */}
            <Typography variant="body2">
              {job.salary || 'N/A'}
              {job.salary && job.payment_frequency && (
                <Box component="span" sx={{ ml: 0.5 }}>
                  {getPaymentFrequencyDisplay(job.payment_frequency)}
                </Box>
              )}
            </Typography>
          </Box>
        }
      />
      <CardContent sx={{ pt: 1, px: 3, pb: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Stack direction="column" spacing={1} mb={1} color="text.secondary">
          <Box display="flex" alignItems="center" gap={0.5}>
            <LocationOnIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">{job.location || 'Location'}</Typography>
          </Box>
          {/* <Box display="flex" alignItems="center" gap={0.5}>
            <AttachMoneyIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">{job.salary || 'N/A'}</Typography>
          </Box> */}
          {/* <Box display="flex" alignItems="center" gap={0.5}>
            <AccessTimeIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">{job.postedDate || job.posted_date || 'Recently'}</Typography>
          </Box> */}
          <Box display="flex" alignItems="center" gap={0.5}>
            <EventIcon sx={{ fontSize: 18 }} />
            <Typography variant="body2">
              Deadline: {job.application_deadline ? new Date(job.application_deadline).toLocaleDateString() : 'Not Applicable'}
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
          {(job.tags || []).map((tag) => (
            <Chip key={tag} label={tag} variant="outlined" size="small" />
          ))}
        </Box>

      </CardContent>

      {/* Profile Completion Modal */}
      <ProfileCompletionModal 
        open={showProfileModal} 
        onClose={() => setShowProfileModal(false)}
        redirectUrl={`/opportunities/${job.uuid}/apply`}
      />
    </Card>
  );
}
